import { ArticleParagraph2, Image, UIHeading4 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { IOfferRowProps } from '../../../types';
import { DeactivatedLabel, Price } from '../../commonComponents';
import { WalkWayMinutes } from '../../commonComponents/WalkWayMinutes';
import { DescriptionItem } from '../DescriptionItem';

export const NarrowOfferRow: React.FC<IOfferRowProps> = props => {
  const { data, testId, onClick, isActive, isViewed, selectable, hideButton } = props;

  return (
    <article
      className={cx(
        styles['container'],
        isActive && styles['active'],
        selectable && styles['selectable'],
        isViewed && styles['viewed'],
      )}
      data-testid={testId}
    >
      <div className={cx(styles['content'])} onClick={onClick}>
        <div className={styles['image']}>
          <Image
            width={150}
            height={150}
            objectFit="cover"
            src={data.previewPhoto || ''}
            preloader
            display="block"
            alt=""
          />
        </div>
        <div>
          {data.deactivatedTitle && (
            <div className={styles['deactivated']}>
              <DeactivatedLabel title={data.deactivatedTitle} />
            </div>
          )}
          <UIHeading4 color="text-main-default">{data.title}</UIHeading4>
          {data.walkWayMinutes && <WalkWayMinutes>{data.walkWayMinutes}</WalkWayMinutes>}
          <div className={styles['price']}>
            <Price diff={data.prices.priceDiff} subprice={data.prices.priceSqm} size="XS">
              {data.prices.price}
            </Price>

            <ArticleParagraph2 color="gray60_100">{data.prices.deposit}</ArticleParagraph2>
            <ArticleParagraph2 color="gray60_100">{data.prices.agentBonusPayment}</ArticleParagraph2>
          </div>
          <div className={styles['description']}>
            <DescriptionItem title="На Циан" value={data.exposition} />
            <DescriptionItem title="Опубликовано" value={data.dateStart} />
            <DescriptionItem title="Снято" value={data.dateEnd} />
          </div>

          {hideButton && <div className={styles['hide-button']}>{hideButton}</div>}
        </div>
      </div>
    </article>
  );
};
